$(document).ready(function() {

  if ($('#shops_map').length > 0) {

    $.ajax({
      url: urls.ajax,
      method: 'get',
      data: {
        'action': 'get-shops'
      }
    }).done( function (response) {
      $('#map_loader').remove();
      let locations = response;
      let image = new google.maps.MarkerImage(img.map_marker, null, new google.maps.Point(0, 0), new google.maps.Point(56, 56), new google.maps.Size(113, 113));
      let map = new google.maps.Map(document.getElementById('map_canvas'), {
            zoom: 12,
            center: new google.maps.LatLng(50.83334319999999, 4.366629399999999),
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            fullscreenControl: false,
            styles: [
              {"featureType": "landscape","stylers": [{"hue": "#FFBB00"},{"saturation": 43.400000000000006},{"lightness": 37.599999999999994},{"gamma": 1}]},
              {"featureType": "road.highway","stylers": [{"hue": "#FFC200"},{"saturation": -61.8},{"lightness": 45.599999999999994},{"gamma": 1}]},
              {"featureType": "road.arterial","stylers": [{"hue": "#FF0300"},{"saturation": -100},{"lightness": 51.19999999999999},{"gamma": 1}]},
              {"featureType": "road.local","stylers": [{"hue": "#FF0300"},{"saturation": -100},{"lightness": 52},{"gamma": 1}]},
              {"featureType": "water","stylers": [{"color": "#b6dee7"}]},
              {"featureType": "poi","stylers": [{"hue": "#00FF6A"},{"saturation": -1.0989010989011234},{"lightness": 11.200000000000017},{"gamma": 1}]}
            ],
          });

      let marker, i, markers = [];
      let infowindow = new google.maps.InfoWindow();
      var gmarkers = [];

      function createMarker(latlng, html) {
          var marker = new google.maps.Marker({
              icon: image,
              position: latlng,
              map: map
          });

          google.maps.event.addListener(marker, 'click', function() {
              infowindow.setContent(html);
              infowindow.open(map, marker);
          });

          google.maps.event.addListener(map, 'click', function() {
              infowindow.close();
          });

          return marker;
      }

      for (i = 0; i < locations.length; i++) {
        let content = '<div id="iw-container">' +
          '<div class="iw-title">'+ locations[i][0] +'</div>' +
          '<div class="iw-content">' +
          '<a href="'+ locations[i][1] +'" target="_blank">' +
          locations[i][1] +
          '</a>' +
          '<div>'+ locations[i][2] +'</br>'+ locations[i][3] +'</div>' +
          '<a href="tel:'+ locations[i][4] +'">' +
          locations[i][4] +
          '</a>' +
          '</div>' +
          '</div>';

        gmarkers[locations[i][0]] = createMarker(new google.maps.LatLng(locations[i][5], locations[i][6]), content);
      }

      if($('#search_by_locality').length) {
        let input = document.getElementById('search_by_locality'),
          options = {
            types: ['(regions)']
          };

        let autocomplete = new google.maps.places.Autocomplete(input, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
          let place = autocomplete.getPlace(),
            lat = place.geometry.location.lat(),
            lng = place.geometry.location.lng();

          let latLng = new google.maps.LatLng(lat, lng);
          map.setCenter(latLng);
        });
      }

      map.addListener('bounds_changed', function () {
        recenterMap();
      });

      map.addListener('center_changed', function () {
        recenterMap();
      });

      google.maps.event.addListener(infowindow, 'domready', function() {

        // Reference to the DIV that wraps the bottom of infowindow
        let iwOuter = $('.gm-style-iw');

        /* Since this div is in a position prior to .gm-div style-iw. */
        let iwBackground = iwOuter.prev();

        // Removes background shadow DIV
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});

        // Removes white background DIV
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});

        // Removes content cursor & cursor shadow
        iwBackground.children(':nth-child(1)').css({'display' : 'none'});
        iwBackground.children(':nth-child(3)').css({'display' : 'none'});

        // Reference to the div that groups the close button elements.
        let iwCloseBtn = iwOuter.next();

        // Apply the desired effect to the close button
        iwCloseBtn.css({display: 'none'});
      });

      let recenterMap = function () {
        let bounds = map.getBounds();

        for (let i = 0; i < markers.length; i++) {
          let marker = markers[i],
            infoPanel = $('.garage-' + (i + 1)); // array indexes start at zero, but not our class names :)

          if (bounds.contains(marker.getPosition()) === true) {
            infoPanel.show();
          } else {
            infoPanel.hide();
          }
        }
      }
    });
  }

});